import html2canvas from "html2canvas";
import moment from "moment";
import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import kadtauliah from "../asset/kadtauliah.jpg";
import request from "./helpers/API";
import {
  fetchSecureFileDataUrl,
  fetchSecureFileObjectUrl,
  resolveMediaFileId,
} from "./helpers/secureFileAccess";
import { useLoginStore } from "./helpers/state";
import defaultavatar from "../asset/defaultavatar.png";

export function DigitalCard() {
  const printRef = useRef();
  const { login } = useLoginStore();
  var CryptoJS = require("crypto-js");
  const [name, setName] = useState("-");
  const [noPekta, setPekta] = useState("-");
  const [nric, setNric] = useState("-");
  const [image, setImage] = useState();
  const [photoFileId, setPhotoFileId] = useState(null);
  const [startDate, setStartDate] = useState("-");
  const [endDate, setEndDate] = useState("-");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const userID = login.id;
  let bytes = CryptoJS.AES.decrypt(login.jwtToken, `${process.env.SECRET_KEY}`);
  var userToken = bytes.toString(CryptoJS.enc.Utf8);
  const navigate = useNavigate();

  const getPEKTA = async (url) => {
    const response = request({
      url,
      method: "GET",
      headers: { Authorization: `Bearer ${userToken}` },
    });
    return response;
  };

  const getTarikh = async (url) => {
    const response = request({
      url,
      method: "GET",
      headers: { Authorization: `Bearer ${userToken}` },
    });
    return response;
  };

  const handleDownloadImage = async () => {
    const element = printRef.current;
    if (!element) return;

    const photoImg = element.querySelector('img[alt="gambar"]');
    const previousSrc = photoImg?.getAttribute("src");

    console.log(photoFileId);
    console.log(photoImg);
    // For Muat Turun, embed as data: URL so html2canvas can draw the face.
    // Do this only on download — Azure SAS often blocks JS reads (CORS).
    if (photoFileId && photoImg) {
      try {
        const dataUrl = await fetchSecureFileDataUrl(photoFileId, userToken);
        console.log(dataUrl);
        if (dataUrl) {
          await new Promise((resolve) => {
            photoImg.onload = resolve;
            photoImg.onerror = resolve;
            photoImg.src = dataUrl;
          });
        }
      } catch (downloadImageError) {
        console.warn(
          "Could not embed photo for download (CORS). Preview will stay on SAS URL.",
          downloadImageError
        );
      }
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "visible";

    try {
      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: false,
        scrollX: 0,
        scrollY: 0,
      });

      const data = canvas.toDataURL("image/png");
      const link = document.createElement("a");

      if (typeof link.download === "string") {
        link.href = data;
        link.download = `kad tauliah ${name}`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(data);
      }
    } finally {
      document.body.style.overflow = originalOverflow;
      if (photoImg && previousSrc) {
        photoImg.src = previousSrc;
      }
    }
  };

  // Preview: use signed URL from access API only (no Azure XHR → no CORS on load)
  const getSecureProfileImage = async (fileId) => {
    try {
      const signedUrl = await fetchSecureFileObjectUrl(fileId, userToken);
      return signedUrl || defaultavatar;
    } catch (error) {
      console.error("Error loading secure profile image:", error);
      return defaultavatar;
    }
  };

  // Fetch user data on component mount
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      setError(null);

      // Fetch user profile data
      const userResult = await getPEKTA(
        `/api/users/${userID}?populate[0]=pekta&populate[1]=pekta.pekta_applications.photo_file`
      );

      if (userResult.data.id_no !== null) {
        setNric(userResult.data.id_no);
        setName(userResult.data.full_name);
        setPekta(userResult.data.registration_number);
      } else if (userResult.data.id_no === null) {
        setNric(userResult.data.pekta.pekta_applications[0].nric);
        setName(userResult.data.full_name);
        setPekta(userResult.data.registration_number);
      }

      // Fetch profile image ids (never use public media .url)
      const imageResult = await getPEKTA(
        `api/users/${userID}?populate[0]=profile_image&populate[1]=pekta.pekta_applications.photo_file`
      );

      const resolvedPhotoFileId = resolveMediaFileId(
        imageResult.data.profile_image,
        imageResult.data.pekta?.pekta_applications?.[0]?.photo_file
      );
      setPhotoFileId(resolvedPhotoFileId);

      const previewImage = resolvedPhotoFileId
        ? await getSecureProfileImage(resolvedPhotoFileId)
        : defaultavatar;
      setImage(previewImage);

      // Fetch date settings
      const dateResult = await getTarikh(`api/pekta-setting`);
      let startDate = moment(
        dateResult.data.data.attributes.katam_start_date
      ).format("DD/MM/YYYY");
      let endDate = moment(
        dateResult.data.data.attributes.katam_expiry_date
      ).format("DD/MM/YYYY");

      setStartDate(startDate);
      setEndDate(endDate);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setError(
        "Gagal memuat data. Sila refresh halaman atau hubungi TH Support."
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (cancelled) return;
      await fetchUserData();
    };

    load();

    return () => {
      cancelled = true;
    };
    // userToken is derived from jwt each render; depend on stable login fields only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID, login.jwtToken]);

  return (
    <div className="m-0 p-0">
      <style>
        {`
          .no-translate {
            -webkit-translate: no;
            translate: no;
          }
          .no-translate * {
            -webkit-translate: no !important;
            translate: no !important;
          }
          
          /* Stop browser/system auto-darkening inside this scope */
          .no-auto-dark {
            color-scheme: light;
            forced-color-adjust: none; /* blocks auto invert on Chrome/Android & Windows HC */
            background: #fff;          /* ensure white bg (also for html2canvas) */
          }

          /* Keep text black regardless of mode */
          .preserve-black, .preserve-black * {
            color: #000 !important;
            -webkit-text-fill-color: #000 !important; /* Safari/iOS */
            text-shadow: none; /* avoids odd halos on dark */
          }
        `}
      </style>
      <div className="justify-between w-full flex flex-row ">
        <button
          className="p-2 bg-gray-500 text-white rounded-sm ml-6"
          onClick={handleDownloadImage}
          disabled={isLoading}
        >
          <span translate="no">Muat Turun</span>
        </button>
        <button
          className="mr-6 text-4xl font-bold"
          onClick={() => navigate("/myprofile")}
        >
          X
        </button>
      </div>
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 flex flex-col items-center shadow-xl">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mb-4"></div>
            <div className="text-lg font-medium text-gray-700" translate="no">
              Memuat data...
            </div>
            <div className="text-sm text-gray-500 mt-2" translate="no">
              Sila tunggu sebentar
            </div>
          </div>
        </div>
      )}
      {error && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 flex flex-col items-center shadow-xl max-w-md mx-4">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <svg
                className="w-8 h-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
            <div
              className="text-lg font-medium text-gray-900 mb-2"
              translate="no"
            >
              Error
            </div>
            <div
              className="text-sm text-gray-600 text-center mb-6"
              translate="no"
            >
              {error}
            </div>
            <div className="flex space-x-3">
              <button
                onClick={() => {
                  setError(null);
                  setIsLoading(true);
                  fetchUserData();
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                translate="no"
              >
                Refresh halaman
              </button>
              <button
                onClick={() => navigate("/myprofile")}
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
                translate="no"
              >
                Kembali
              </button>
            </div>
          </div>
        </div>
      )}
      {!isLoading && (
        <div
          ref={printRef}
          className="xl:max-w-lg sm:max-w-lg m-auto xl:h-full sm:h-1/3 no-translate no-auto-dark"
          translate="no"
        >
          <div className="p-0 relative w-full h-auto">
            {/* kadtauliah background */}
            <img src={kadtauliah} alt="kad tauliah" className="w-full h-auto" />

            {/* NO. PEKTA overlay */}
            <div
              className="absolute z-10 pointer-events-none"
              style={{
                left: "4%",
                top: "7%",
              }}
            >
              <p
                className="leading-tight text-[2.8vw] sm:text-lg xs:text-md preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                NO. PEKTA:
              </p>
              <p
                className="mt-0 font-bold leading-tight text-[3.2vw] sm:text-lg xs:text-md preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                {noPekta}
              </p>
            </div>

            {/* User image overlay in green box */}
            <div
              className="absolute"
              style={{
                left: "15.1%",
                top: "17.5%",
                width: "36%",
                height: "30%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={image || defaultavatar}
                alt="gambar"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Personal Information overlay */}
            <div
              className="absolute z-10 pointer-events-none"
              style={{
                left: "14%",
                top: "70%",
              }}
            >
              <p
                className="leading-tight text-[2.6vw] sm:text-base xs:text-sm preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                NAMA:
              </p>
              <p
                className="mt-0 font-bold leading-tight text-[3.2vw] sm:text-lg xs:text-md preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                {name}
              </p>
              <p
                className="leading-tight text-[2.6vw] sm:text-base xs:text-sm preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                NO. KAD PENGENALAN:
              </p>
              <p
                className="mt-0 font-bold leading-tight text-[3.2vw] sm:text-lg xs:text-md preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                {nric}
              </p>
              <p
                className="leading-tight text-[2.6vw] sm:text-base xs:text-sm preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                TEMPOH SAH:
              </p>
              <p
                className="mt-0 font-bold leading-tight text-[3.2vw] sm:text-lg xs:text-md preserve-black"
                style={{ color: "#000000 !important" }}
                translate="no"
              >
                {startDate}-{endDate}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
// IF NOT DATA, ON PEKTA PROFILE SIDE, PULL FROM AKAUN SAYA.
